import { doc, getDoc } from "firebase/firestore";
import { firestore as db } from "../../../../../backend/firebaseconfig";


export async function getHighRiskCountries() {
  try {
    const ref = doc(
      db,
      "Compliance",
      "High Risk And Non Cooperative Countries"
    );
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      // console.warn("High-risk countries: document not found");
      return [];
    }

    const data = snap.data();
    // console.log("High-risk countries data:", data.list);
    return data.list || [];
  } catch (err) {
    // console.error("Failed to fetch high-risk countries:", err);
    return [];
  }
}
